import platform from "./platform";

const CASHBACK_URL = platform.CASHBACK_URL;

const settings =  {
    GG_API_KEY: 'AIzaSyCxnwwodHLne5PdeJpCwghZF2psRztcjjc',
    BASE_URL : CASHBACK_URL,
    POS_PUBLIC_URL: CASHBACK_URL + '/cashpub/pos/',
    POS_POSITION_PUBLIC_URL: CASHBACK_URL + '/cashpub/pos/position/',
    PLATFORM: platform
}

export default settings
